import React from "react";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  formControl: { margin: 0 },
  filterSelectRoot: { padding: 10, backgroundColor: "white" }
}));

const OSSSelectFilter = ({ filter = {}, query = {} }) => {
  const classes = useStyles();
  const {
    matchKey = "val",
    displayKey = null,
    name = "",
    label = "",
    labelWidth = 60,
    options = [],
    onSelect = () => {}
  } = filter;

  const handleChange = (key, e) => {
    return onSelect(key, e.target.value);
  };

  return (
    <FormControl
      className={classes.formControl}
      margin="dense"
      variant="outlined"
      fullWidth
    >
      <InputLabel id="">{label}</InputLabel>
      <Select
        id={`${name}-select`}
        value={query[name] || ``}
        onChange={e => handleChange(name, e)}
        classes={{ root: classes.filterSelectRoot }}
        labelWidth={labelWidth}
      >
        <MenuItem key="empty" value="">
          <em>No Filter</em>
        </MenuItem>
        {options
          .sort((a, b) => a[matchKey].localeCompare(b[matchKey]))
          .map((opt, index) => (
            <MenuItem key={index} value={opt[matchKey]}>
              {opt[displayKey ? displayKey : matchKey]}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};

export default OSSSelectFilter;
